/* 10 · L’élégance dans chaque détail (Shopify : assets/obaia-section-emballage.js)
   Vidéo : lecture automatique sans son et en boucle quand elle est visible à 50 %, pause hors de l’écran.
   Bouton lecture / pause toujours disponible (un clic sur la vidéo fait de même).
   « Réduire les animations » : image fixe, la vidéo ne se lance qu’au clic. */
OBAIA.section('emballage', {
  init: function (root) {
    OBAIA.$$('[data-video]', root).forEach(function (box) {
      var video = OBAIA.$('video', box), btn = OBAIA.$('[data-video-toggle]', box);
      var userPaused = false;
      function sync() {
        var playing = !video.paused;
        box.classList.toggle('is-playing', playing);
        var T = window.OBAIA_T || {};
        btn.setAttribute('aria-label', playing ? (T.pause_video || 'Mettre la vidéo en pause') : (T.lire_video || 'Lire la vidéo'));
      }
      function play() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      box.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      });
      if (OBAIA.reduce || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!userPaused) play(); }
          else if (!video.paused) video.pause();
        });
      }, { threshold: [0, 0.5] }).observe(box);
    });
  }
});
